import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'travel-ui-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss']
})
export class CounterComponent implements OnInit {
  /*  @Input()
    set config(val) {
      this.jumpBy = val && val.jumpBy && Number(val.jumpBy) ? val.jumpBy : 1;
      this.minValue =
        val && val.minValue && Number(val.minValue) ? val.minValue : 0;
      this.value = val.value ? parseInt(val.value.toString(), 10) : 0;
    }*/

  /**
   * Returns an object with previousValue and newValue
   */
  @Output() numberChange = new EventEmitter();

  @Input() value = 0;
  @Input() maxValue = 0;
  @Input() minValue = 0;

  disableMaxBtn = false;
  disableMinBtn = false;
  jumpBy = 1;
  //  maxValue = null; 
  // minValue = 0;
  //  value = 0;

  constructor() { }

  ngOnInit() {
    this.checkBtnDisable();
  }

  ngOnChanges(changes: any): void {
    this.checkBtnDisable();
  }

  subtract() {
    if (this.value > this.minValue) {
      const whatToEmit:any = {
        previousValue: this.value
      };
      this.value = this.value - this.jumpBy;
      whatToEmit['newValue'] = this.value;
      this.numberChange.emit(whatToEmit);
      this.checkBtnDisable();
    }
  }

  add() {
    if (this.value < this.maxValue) {
      const whatToEmit: any = {
        previousValue: this.value
      };
      this.value += this.jumpBy;
      whatToEmit['newValue'] = this.value;
      this.numberChange.emit(whatToEmit);
      this.checkBtnDisable();
    }
  }

  checkBtnDisable() {
    this.disableMaxBtn = this.value === this.maxValue;
    this.disableMinBtn = this.value === this.minValue;
  }

}
